module.exports = __webpack_public_path__ + "img/tab_img_m1.64b27ff4.png";